import styled from "styled-components";

export const Container = styled.div `
`

export const Content = styled.div `

    margin-top: 20px;

    aside {
        display: flex;
        max-width: 100%;
        overflow-x: auto;
        border-bottom: 2px solid #707070;
    }

    aside a {
        display: flex;
        color: #fff;
        margin-right: 20px;
        font-weight: 600;
        padding: 10px;
        font-size: .9rem;
        color: #aaa;
        white-space: nowrap;
        transition: all .3s ease;
    }

    .active {
        border-bottom: 2px solid #fff;
        color: #fff;
    }

    @media (max-width: 600px) {
        
        aside::-webkit-scrollbar {
            display: none;
        }

    }
`